import s from './strings'

const HELP_URL = 'https://help.doordash.com'

type FAQLinkType = {
  url: string
  text: string
}

export const FAQs: FAQLinkType[] = [
  {
    // tslint:disable-next-line:max-line-length
    url: `${HELP_URL}/dashers/s/article/How-to-use-the-Dash-Now-home-page?language=en_US`,
    text: s.q1(),
  },
  {
    // tslint:disable-next-line:max-line-length
    url: `${HELP_URL}/dashers/s/article/How-do-I-update-my-bank-account-information?language=en_US`,
    text: s.q2(),
  },
  {
    url: `${HELP_URL}/dashers/s/article/How-to-schedule-a-dash?language=en_US`,
    text: s.q3(),
  },
  {
    // tslint:disable-next-line:max-line-length
    url: `${HELP_URL}/dashers/s/article/How-is-Dasher-pay-calculated?language=en_US`,
    text: s.q4(),
  },
]
